import * as types from './types';

const initialState = {
  preDeals: [],
  isFetchingPreDeals: false,
  isPreDealDownloading: false,
  selectedPreDeal: undefined,
  currentPage: 0,
  total: 0,
  pageSize: 25,
  counties: [],
  markets: [],
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_PRE_DEALS:
    case types.SET_IS_FETCHING_PRE_DEALS:
    case types.SET_IS_DOWNLOAD_PRE_DEALS:
    case types.SET_PRE_DEAL:
    case types.SET_CURRENT_PAGE:
    case types.SET_PAGE_SIZE:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
